import { useAutoneTranslation } from '@autone/translations';
import { forwardRef } from 'react';

import { Button, type ButtonProps, cn } from '../../../../../../tailwind';
import { useChangeFiltersPopoverViewContext } from '../../../ChangeFiltersPopoverView.context';

export const GoBackButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const { common } = useAutoneTranslation();
    const [, dispatch] = useChangeFiltersPopoverViewContext();
    return (
      <Button
        onClick={() => dispatch({ type: 'GO_BACK' })}
        variant="outlined"
        color="secondary"
        className={cn('border-grey-20 hover:bg-grey-5', className)}
        ref={ref}
        {...props}
      >
        {common('go-back')}
      </Button>
    );
  },
);
